export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const GET_USER = 'GET_USER';
export const GET_LOGGED_IN_USER_PROFILE = 'GET_LOGGED_IN_USER_PROFILE';
export const GET_LOGGED_IN_USER = 'GET_LOGGED_IN_USER';
